import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {TuiButton, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface GateweeJsonPreviewDialogData {
  title: string;
  content: string;
}

@Component({
  selector: 'gatewee-json-preview-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, TuiButton],
  template: `
    <div class="gw-space-y-small gw-p-medium">
      <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
        {{ data.title }}
      </h2>

      <pre
        class="gw-max-h-[min(60vh,24rem)] gw-overflow-auto gw-whitespace-pre-wrap gw-break-words gw-rounded-lg gw-border gw-border-solid gw-border-border-normal gw-bg-background-neutral-1 gw-p-small gw-text-xs gw-text-text-primary"
        >{{ data.content }}</pre
      >

      <div class="gw-flex gw-justify-end gw-pt-2x-small">
        <button tuiButton appearance="primary" type="button" (click)="close()">
          {{ 'common.actions.ok' | translate }}
        </button>
      </div>
    </div>
  `,
})
export class GateweeJsonPreviewDialogComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<
      void,
      GateweeJsonPreviewDialogData
    >,
  ) {}

  get data(): GateweeJsonPreviewDialogData {
    return this.context.data;
  }

  close(): void {
    this.context.completeWith();
  }
}
